import { SVGAttributes } from "react";

export const Group3Icon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 17V7H4.092A.57.57 0 004 7.333v9.334c0 .168.053.28.092.333H8zm12 2c1.105 0 2-1.045 2-2.333V7.333C22 6.045 21.105 5 20 5H4C2.895 5 2 6.045 2 7.333v9.334C2 17.955 2.895 19 4 19h16zM10 7v10h4V7h-4zm6 0v10h3.907a.57.57 0 00.093-.333V7.333A.57.57 0 0019.907 7H16z"
        fill="currentColor"
      />
    </svg>
  );
};
Group3Icon.displayName = "Group3Icon";
